import * as React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

export interface IContactInfoProps {
  email: string;
  name: string;
  onClick?: () => void;
  organization?: string;
  phone: string;
}

const ContactInfo: React.FC<IContactInfoProps> = (props) => (
  <Col className="py-6">
    {props.organization ? (
      <Text as="p" className="text-label-md">
        {props.organization}
      </Text>
    ) : null}
    <Text as="p" className="text-body-md">
      {props.name}
    </Text>
    <a href={`mailto:${props.email}`} onClick={props.onClick}>
      {props.email}
    </a>
    <Text as="p" className="text-body-md">
      {props.phone}
    </Text>
  </Col>
);

export default ContactInfo;
